export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11198.c1c1f185.jpg";